export default __webpack_public_path__ + "static/media/D_Dado.da9193ec.svg";